var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TooltipWrapper } from '@zapier/design-system/dist/components/display/TooltipWrapper';
import { Button, DefaultButtonColors, } from '@zapier/design-system/dist/components/navigation/Button';
import { Icon, } from '@zapier/design-system/dist/components/display/Icon';
import { isolateComponent } from '@zapier/common-utils';
const buttonSizeToIconSize = {
    medium: 24,
    small: 24,
    xsmall: 18,
};
export function IconButton(_a) {
    var { icon, iconSize, label, shouldCorrectTooltipPosition, tooltipPosition } = _a, buttonProps = __rest(_a, ["icon", "iconSize", "label", "shouldCorrectTooltipPosition", "tooltipPosition"]);
    return (isolateComponent(TooltipWrapper, { content: label, position: tooltipPosition, shouldCorrectPosition: shouldCorrectTooltipPosition, showTooltipOnTouchDevices: false }, ({ childProps }) => (isolateComponent(Button, Object.assign({ ariaLabel: label }, buttonProps, childProps, { isSquare: true }),
        isolateComponent(Icon, { canAcceptPointerEvents: false, isBlock: true, name: icon, size: iconSize || buttonSizeToIconSize[buttonProps.size] })))));
}
IconButton.defaultProps = {
    color: 'greyAlt',
    colorTheme: DefaultButtonColors,
    size: 'small',
    tooltipPosition: 'south',
};
//# sourceMappingURL=IconButton.js.map
